import React, {useMemo} from 'react';
import {useProjectTelReportsByEstablishedYearRangeQuery} from 'api';
import {useParams} from 'react-router-dom';
import Table from '../Table';

export default () => {
  const {projectId} = useParams<{projectId: string}>();

  const {data: {projectTelReportsByEstablishedYearRange = []} = {}} =
    useProjectTelReportsByEstablishedYearRangeQuery({
      variables: {uuid: projectId},
      fetchPolicy: 'cache-and-network',
    });

  const data: any = useMemo(
    () =>
      projectTelReportsByEstablishedYearRange.map((report) => {
        return {
          name: report.establishedYearRange,
          callCount: report.callCount,
          contactCount: report.contactCount,
          contactCallRate: report.contactCallRate,
          documentCount: report.documentCount,
          documentCallRate: report.documentCallRate,
          appointCount: report.appointCount,
          appointCallRate: report.appointCallRate,
        };
      }),
    [projectTelReportsByEstablishedYearRange],
  );

  return <Table data={data} />;
};
